module.exports = __webpack_public_path__ + "img/add-user.3169dc57.svg";